import { useI18N } from "@sundae/react-hooks";
import { Tooltip } from "@sundae/ui-toolkit";
import { FC, PropsWithChildren, memo } from "react";

interface IMarketOpenTooltipProps {
  openDate: string;
}

const MarketOpenTooltip: FC<PropsWithChildren<IMarketOpenTooltipProps>> = ({
  children,
  openDate,
}) => {
  const { t } = useI18N("warnings");
  return (
    <Tooltip
      trigger={<div className="cursor-help">{children}</div>}
      tooltipLabel={t("warning.marketOpen", {
        date: openDate,
      })}
    />
  );
};

export default memo(MarketOpenTooltip);
